import React from 'react'
import { useSocket } from '../context/socketProvider'
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
export default function Lobby() {
    const socket = useSocket();
    const history = useNavigate()
    const [email,setEmail] = useState('');
    const [roomId,setRoomId] = useState('');

    const handleSubmit = (e)=>{ 
        e.preventDefault();
        socket.emit("enter-room",{email,roomId})
        setEmail('');
        setRoomId('');
history(`room/${roomId}`)
    }

  return (
    <div style={{display:"flex",justifyContent:'center',gap:"5px",alignItems:"center",height:"100vh"}}>
       <input onChange={e=>setEmail(e.target.value)} type='text' value={email} placeholder='Enter email' />
        <input onChange={e=>setRoomId(e.target.value)} type='text' value={roomId} placeholder='Enter room Id' />
        <button onClick={handleSubmit}>Enter room</button>
    </div>
  )
}
